<template>
    <div>
        <img
            src="@/assets/img/hero-mobile.jpg"
            alt="Model picture"
            class="model-picture--mobile"
        />
    </div>
</template>

<style lang="scss" scoped></style>
